import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemsSection } from '../components/ProblemsSection';
import { AboutSection } from '../components/AboutSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { FreeSessionSection } from '../components/FreeSessionSection';
import { FooterCTA } from '../components/FooterCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-brand-black text-brand-white font-body selection:bg-brand-accent selection:text-brand-black" data-id="element-212">
      <Navbar data-id="element-213" />

      <main data-id="element-214">
        <HeroSection data-id="element-215" />
        <ProblemsSection data-id="element-216" />
        <AboutSection data-id="element-217" />
        <MethodSection data-id="element-218" />
        <OfferSection data-id="element-219" />
        <FreeSessionSection data-id="element-220" />
        {/* Testimonials section is skipped as per brief instructions */}
        <FooterCTA data-id="element-221" />
      </main>

      <Footer data-id="element-222" />
    </div>;
}